
import React, { useEffect } from 'react';

const GenericError = (props) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  });
  
  const { errorType } = props;

  return (
    <>
    <div className="genericError">
      <div className="max-width-5 mx-auto clearfix">
          <div className="col col-12 px2" style={{ display: (errorType === '404') ? "block": "none"}}>
              <h4>404 page is not found</h4>
          </div>
          <div className="col col-12 px2" style={{ display: (errorType === '500') ? "block": "none"}}>
              <h4>500 Internal server error</h4>
          </div>
        </div>
    </div>
    </>
  )
}


export default GenericError;
